import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Dashboard from '../../../assets/DashboardsLight.svg';
import Attainment from '../../../assets/AttainmentLight.svg';
import Reports from '../../../assets/ReportsLight.svg';
import Survey from '../../../assets/SurveyLight.svg';
import FacultyContribution from '../../../assets/FacultyLight.svg';
import Assessments from '../../../assets/AssessmentsLight.svg';
import Utilities from '../../../assets/UtilitiesLight.svg';
import Curriculum from '../../../assets/CurriculumLight.svg';
import CustomDashboardCard from '../../../constants/CustomDashboardCard'
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

}));
const Index = () => {
  const classes = useStyles();
  return (
    <div className={classes.root} >
      <Grid container spacing={3} className="my-5">
      <Grid item xs={3}>
          <CustomDashboardCard image={Dashboard} title={"Dashboard"} link={'/dashboard'}/>
        </Grid>
        <Grid item xs={3}>
        <CustomDashboardCard image={Attainment} title={"Attainment"} link={'/attainment'}/>
        </Grid>
        <Grid item xs={3}>
        <CustomDashboardCard image={Reports} title={"Reports"} link={'/reports'}/>
        </Grid>
        <Grid item xs={3}>
        <CustomDashboardCard image={Survey} title={"Survey"} link={'/survey'}/>
        </Grid>
      </Grid>



      <Grid container spacing={3} className="mb-4">
      <Grid item xs={3}>
          <CustomDashboardCard image={FacultyContribution} title={"Faculty Contribution"} link={'/faculty-contribution'}/>
        </Grid>
        <Grid item xs={3}>
        <CustomDashboardCard image={Assessments} title={"Assessments"} link={'/assessments'}/>
        </Grid>
        <Grid item xs={3}>
        <CustomDashboardCard image={Utilities} title={"Utilities"} link={'/utilities'}/>
        </Grid>
        <Grid item xs={3}>
        <CustomDashboardCard image={Curriculum} title={"Curriculum"} link={'/curriculum'}/>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
